import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_parenthood from '../../images/personality_types_details/diplomats_Campaigner_ENFP_parenthood.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfp_parents = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress active">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>

                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Parenthood</h1>


                        <p>If there is anything that makes Campaigners great parents, it’s the sense of wonder they have for all things new and beautiful, a sense that they will be able to share with their children every day as they learn and grow. Throughout their children’s lives, Campaigners provide a combination of almost overwhelming love and support, and an unstructured environment revolving around freedom and creativity. This in no way means that people with the Campaigner personality type will simply leave their children to their own devices without guidance – rather, Campaigner parents want to share in their children’s perspective, share in a world without bounds.</p>

                        <p>Campaigner parents are playful and warm, and love to see their children excited, playing in and experimenting with the world around them. It is likely that Campaigner parents will encourage this play and growth by suggesting activities and lessons.</p>

                        <div class="scene">
                            <img alt="Campaigner parents" src={diplomats_Campaigner_ENFP_parenthood} alt="Campaigner parents" />
                        </div>

                        <div class="description-pullout">Campaigners will embrace and encourage productive interests as they arise, sweeping away dolls and dinosaurs when interests shift to the oceans, and sweeping away the fish when tastes change again, to the stars.</div>

                        <p>While they often enough recognize the value of structure and predictability, Campaigner parents are unlikely to have the heart (or as they may see it, the lack of heart) to establish these limitations themselves. They may need to depend on their partners to provide some necessary guidelines and discipline from time to time, but Campaigner parents will always have the advantage of their open-minded and empathetic nature, making them not just parents, but friends who their children feel comfortable confiding in. They needn’t always depend on their children broaching the subject either, as Campaigners have a natural skill in spotting emotional disharmony or physical discomfort in others.</p>

                        <h2>Go On, Spread Your Wings</h2>

                        <p>As their children approach the teenage years, all this emotion and attention can start to cloy, and their children may seek a more private independence. This can be a challenge for people with the Campaigner personality type – they have strong emotions, and invest those emotions heavily in the things and people they care about. While they may not be big on using proven ideas, Campaigners do like to see whether or not their ideas work, and this applies to their thoughts on parenting, too. As their adolescent children withdraw, they leave an unsolved mystery that can last for years, leaving their Campaigner parents wondering if their ideas on raising their children actually work, actually result in happy, independent and creative adults.</p>

                        <p>Luckily for them, so long as they raise their children with a sense of productive independence, rather than an aimless, against-the-grain antipathy, Campaigners will find that their children have developed a strong sense of self and self-worth, going confidently out into the big, wide world at their own pace and in their own style, knowing that they have both themselves and their Campaigner parents to depend on.</p>

                        <div class="number">05</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfp-friends' className='next-feature'>
                            Friendships
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfp-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default enfp_parents
